import { render, staticRenderFns } from "./TabelaValidadores.vue?vue&type=template&id=883badf0&scoped=true&"
import script from "./TabelaValidadores.vue?vue&type=script&lang=js&"
export * from "./TabelaValidadores.vue?vue&type=script&lang=js&"
import style0 from "./TabelaValidadores.vue?vue&type=style&index=0&id=883badf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883badf0",
  null
  
)

export default component.exports